<div class="landing-managment-container">

  <header class="page-header">
    <h1 class="page-title">Gestión De Página De Inicio</h1>
  </header>

  @if (isLoading()) {
    <p class="loading-state">Cargando datos...</p>
  } @else {

    <section class="landing-section">
      <h2 class="section-title">Productos Destacados</h2>

      <div class="product-grid product-grid--row">
        @for (slot of featuredSlots(); track $index) {
          <div class="product-card">
            @if (slot) {
              <div class="product-card__image-wrapper">
                <img
                  class="product-card__image"
                  [src]="slot.imageUrl"
                  [alt]="slot.name"
                />
              </div>
              <p class="product-card__name">{{ slot.name }}</p>
              @if (isComingSoon(slot)) {
                <span class="product-card__badge">{{ texts.COMING_SOON_BADGE }}</span>
                <p class="product-card__warning" role="note">{{ texts.COMING_SOON_WARNING }}</p>
              }
              <div class="product-card__actions">
                <button
                  type="button"
                  class="btn-primary"
                  (click)="onEditFeaturedProduct($index)"
                >
                  Editar
                </button>
                <button
                  type="button"
                  class="btn-danger"
                  (click)="onRemoveFeaturedProduct($index)"
                >
                  Eliminar
                </button>
              </div>
            } @else {
              <div class="product-card__image-wrapper product-card__image-wrapper--empty">
                <span class="product-card__add-icon">+</span>
              </div>
              <p class="product-card__name product-card__name--muted">Sin producto</p>
              <button
                type="button"
                class="btn-secondary"
                (click)="onAddFeaturedProduct($index)"
              >
                Agregar
              </button>
            }
          </div>
        }
      </div>
    </section>

    <section class="landing-section">
      <h2 class="section-title">Mandala Destacada</h2>

      <div class="product-grid">
        <div class="product-card">
          @if (plantProduct()) {
            <div class="product-card__image-wrapper">
              <img
                class="product-card__image"
                [src]="plantProduct()!.imageUrl"
                [alt]="plantProduct()!.name"
              />
            </div>
            <p class="product-card__name">{{ plantProduct()!.name }}</p>
            @if (isComingSoon(plantProduct()!)) {
              <span class="product-card__badge">{{ texts.COMING_SOON_BADGE }}</span>
              <p class="product-card__warning" role="note">{{ texts.COMING_SOON_WARNING }}</p>
            }
            <div class="product-card__actions">
              <button
                type="button"
                class="btn-primary"
                (click)="onEditPlantProduct()"
              >
                Editar
              </button>
              <button
                type="button"
                class="btn-danger"
                (click)="onRemovePlantProduct()"
              >
                Eliminar
              </button>
            </div>
          } @else {
            <div class="product-card__image-wrapper product-card__image-wrapper--empty">
              <span class="product-card__add-icon">+</span>
            </div>
            <p class="product-card__name product-card__name--muted">Sin producto</p>
            <button
              type="button"
              class="btn-secondary"
              (click)="onAddPlantProduct()"
            >
              Agregar
            </button>
          }
        </div>
      </div>
    </section>

  }

</div>
